module.exports = __webpack_public_path__ + "media/images/sp/reserve/key-a5e8c83879c1998a6d1257d404cc7e0b.svg";